// imports
import Accordion from 'minsky-kit/js/components/Accordion';
import { strToCssClass } from 'minsky-kit/js/utils/css';

// private statics

// class definition
export default class WAccordion extends Accordion {
    // constructor
    constructor (args = {}, objectName = 'Accordion') {
        args.debug = args.debug || false;

        const originalObjectName = objectName;
        objectName = 'Accordion';

        // class management
        args.$el.classList.add(strToCssClass(objectName, null, originalObjectName.replace('Accordion', '')));

        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
